import { useEffect, useState } from 'react';

export const useMagicBlocksAvailable = () => {
    const [available, setAvailable] = useState(false);

    useEffect(() => {
        if (document.querySelector("magicblocks-widget")) {
            setAvailable(true);
            return;
        };

        const observer = new MutationObserver(() => {
            if (document.querySelector("magicblocks-widget")) {
                setAvailable(true);
                observer.disconnect();
            };
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => observer.disconnect();
    }, []);

    return available;
};